import { render } from "./card-content.vue?vue&type=template&id=1ea382e7&scoped=true"
import script from "./card-content.vue?vue&type=script&lang=js"
export * from "./card-content.vue?vue&type=script&lang=js"

import "./card-content.vue?vue&type=style&index=0&id=1ea382e7&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea382e7"]])

export default __exports__